// extracted by mini-css-extract-plugin
export default {"appBody":"App_appBody__wkvg7","contentBody":"App_contentBody__LZb-V","overlayBody":"App_overlayBody__0VeP8","customOverlay":"App_customOverlay__NaJKB"};